import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { Ownership } from "../../models/ownership";
import { OwnershipPermissionType } from "../../models/ownership-permission";
import { Directive } from "@angular/core";

@Directive()
export class BaseError {
  public successes = [];

  constructor(public toastr: ToastrService) {
  }

  public responseSuccessful(message: any) {
    // debounce messages if too many messages were sent with the same arguments with too small period
    const self = this;
    if (self.successes.indexOf(message) !== -1) {
      return;
    }
    self.successes.push(message);
    setTimeout(() => {
      self.successes.splice(message);
    }, 500);
    self.toastr.toastrConfig.closeButton = false;
    self.toastr.toastrConfig.timeOut = 5000;
    self.toastr.toastrConfig.extendedTimeOut = 5000;
    self.toastr.toastrConfig.tapToDismiss = true;
    self.toastr.toastrConfig.progressBar = true;
    self.toastr.toastrConfig.progressAnimation = "increasing";
    self.toastr.success(message);
  }

  public showErrorMessage(error: any) {
    this.showErrorMessageWithTitle("Error", error);
  }

  public error(message: string, title: string) {
    this.toastr.toastrConfig.closeButton = true;
    this.toastr.toastrConfig.timeOut = 10000;
    this.toastr.toastrConfig.extendedTimeOut = 5000;
    this.toastr.toastrConfig.tapToDismiss = true;
    this.toastr.error(message, title);
  }

  public isEntityNotFound(res: any): boolean {
    return res && res.status === 404 && res.error && res.error.code === "ENTITY_NOT_FOUND";
  }

  public showErrorMessageWithTitle(title: string, res: any) {
    if (res.status === 401) {
      // Do not reload if already on login page (concurrency issues between auth.guard and wrapper.ts)
      if (!window.location.href.includes("login")) {
        window.location.assign("/login");
      }
    } else if (res.status === 502 || res.status === 503 || res.status === 504 || res.status === 0) {
      this.error("Backend service temporarily unavailable. Please try again.", "Error");
    } else if (this.isEntityNotFound(res)) {
      // Suppress the toast: callers are expected to render an inline empty-state
      // (see <app-entity-not-found>). Returning early avoids the sticky raw-message toast.
      return;
    } else {
      const parsedResponse = res._body ? JSON.parse(res._body) : res;
      const message = this.getMessage(parsedResponse);
      if (message !== "") {
        this.error(message, title);
      }
      if (parsedResponse.errors) {
        for (const err of parsedResponse.errors) {
          if (err.defaultMessage) {
            title = "Validation error with " + err.objectName + " " + err.field;
            this.error(err.defaultMessage, title);
          } else {
            this.error(err, title);
          }
        }
      }
    }
  }

  public getMessage(res: any) {
    let message = "";
    if (res.error) {
      if (res.error.message) {
          if (res.error.message === "No message available") {
              message += "Backend problem occured. Please contact your system administrator";
          } else {
              message += res.error.message;
          }
      } else if (res.error.error) {
        message += res.error.error;
      }
      if (res.error.errors) {
        res.error.errors.forEach((err) => {
          if (err.defaultMessage) {
            message += "\n" + err.defaultMessage;
          } else {
            message += "\n" + err;
          }
        });
      }
      if (_.isString(res.error)) {
        try {
          res.error = JSON.parse(res.error);
          return this.getMessage(res);
        } catch (e) {
          message += res.message;

        }
      }
    } else if (res.message) {
      message += res.message;
    }
    return message;
  }

  public isFieldDisabled(ownership: Ownership): boolean {
    if (ownership && ownership.permission) {
      return (ownership.permission === OwnershipPermissionType.Read
        || ownership.permission === OwnershipPermissionType.None);
    }
    return false;
  }
}
